module.exports = __webpack_public_path__ + "static/media/close.cf82c8ee.svg";